import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Spacer,
  useColorModeValue,
  useDisclosure,
  Text,
} from '@chakra-ui/react';
import useDraggable, { OnDrag } from '../../../core/hooks/useDraggable';
import { WindowSizes } from '../../constants/windowSizes';
import { IconType } from 'react-icons/lib';
import { IoMdClose } from 'react-icons/io';
import { FiMaximize2, FiMinimize2 } from 'react-icons/fi';
import { VscChromeMinimize } from 'react-icons/vsc';
import { t } from 'i18next';
import { LuSettings2 } from 'react-icons/lu';
import { AiOutlineGroup } from 'react-icons/ai';
import { BiSpreadsheet } from 'react-icons/bi';
import { ApplicationType, WindowMetaData } from '../../types';
import { RootState } from '../../../core/redux/store';
import { useAppDispatch, useAppSelector } from '../../../core/hooks/storeHooks';
import { closeWindow } from '../../redux/windowsSlice';
import { closeGroup } from '../../../sheet/redux/sheetsManagerSlice';

interface ControlProps {
  windowId: string;
  x: number;
  y: number;
  onDrag: OnDrag;
  metaData?: WindowMetaData;
}
const ControlBar: React.FC<ControlProps> = ({
  windowId,
  x,
  y,
  onDrag,
  metaData,
}) => {
  const dispatch = useAppDispatch();
  const { onMouseDown } = useDraggable({ x, y, onDrag });
  const { isOpen, onOpen, onClose } = useDisclosure();

  // const titleBarColor = useColorModeValue('gray.300', 'gray.200');
  // const titleBarTextColor = useColorModeValue('white', 'gray.800');
  const background = useColorModeValue('#f5f8fa', '#161718'); //f1f5f8

  const title = useAppSelector((state) => getControlbarTitle(state, metaData));

  const handleCloseControlCenter = () => {
    // TODO: Focus sheet back
    onClose();
  };

  const handleCloseWindow = () => {
    dispatch(closeWindow(windowId));
    if (metaData && metaData.appType === ApplicationType.Sheet) {
      dispatch(closeGroup(metaData.groupId));
    }
  };

  const actionButtonView = (
    Icon: IconType,
    label: string,
    onClick: () => void
  ) => (
    <IconButton
      icon={<Icon />}
      aria-label={label}
      mr={1}
      boxSize="25px"
      colorScheme={label === 'close' ? 'red' : 'gray'}
      borderRadius="9px"
      fontSize={15}
      variant="ghost"
      onClick={onClick}
    />
  );

  const sheetControlCenter = () => (
    <Menu isOpen={isOpen} onClose={handleCloseControlCenter}>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<LuSettings2 />}
        boxSize={'25px'}
        mr={1}
        variant="ghost"
        colorScheme="blue"
        onClick={onOpen}
      />
      <Portal>
        <MenuList
          zIndex={1000}
          width="300px"
          display="flex"
          borderRadius="15px"
          boxShadow="lg"
          border="none"
        >
          Sheet Control center
          {/* <MenuItem>{t('controls.settings')}</MenuItem> */}
          {/* <MenuItem onClick={logout}>{t('controls.logout')}</MenuItem> */}
        </MenuList>
      </Portal>
    </Menu>
  );

  const nameView = () => (
    <Box
      display="flex"
      alignItems="center"
      ml={3}
      bg="InfoBackground"
      // background={background}
      // padding="0px 5px"
    >
      <Icon as={BiSpreadsheet} mr={2} fontSize="20px" />
      <Text fontWeight="bold">{title}</Text>
    </Box>
  );

  return (
    <Box
      height={WindowSizes.controlBarHeight}
      width="100%"
      cursor="move"
      borderTopLeftRadius={10}
      borderTopRightRadius={10}
      onMouseDown={onMouseDown}
      // bg="red"
      padding={0}
      display="flex"
      alignItems="center"
      // background={background}
      // boxShadow="sm"
    >
      {nameView()}
      <Spacer />
      {sheetControlCenter()}
      {actionButtonView(VscChromeMinimize, 'min', () => {})}
      {actionButtonView(FiMaximize2, 'max', () => {})}
      {actionButtonView(IoMdClose, 'close', handleCloseWindow)}
      {/* Controlbar */}
    </Box>
  );
};

const getControlbarTitle = (state: RootState, metaData?: WindowMetaData) => {
  if (!metaData) return '';
  if (metaData?.appType === ApplicationType.Sheet) {
    if (state.sheetsManager.groups[metaData.groupId])
      return state.sheetsManager.groups[metaData.groupId]?.name ?? 'Sheets';
  }

  return '';
};

export default ControlBar;
